export const WHATSAPP_NUMBER = '13233855169';
export const WHATSAPP_DISPLAY = '+1 (323) 385-5169';

export function buildWhatsappUrl(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function productOrderUrl(productName: string): string {
  return buildWhatsappUrl(
    `Hola, quiero consultar disponibilidad y hacer mi pedido de ${productName}.`,
  );
}

export const GENERAL_ENQUIRY_URL = buildWhatsappUrl(
  'Hola, quiero consultar disponibilidad y hacer mi pedido.',
);

export const SPECIFIC_FRAGRANCE_URL = buildWhatsappUrl(
  'Hola, busco una fragancia específica: ',
);
